export const API_ROOT = process.env.REACT_APP_API || 'https://v-room.app';

export const FALLBACK_FEATURES = [
  { id: 'fallback-map', title: 'MAPA NA ŻYWO', description: 'Znajomi, ostrzeżenia i najważniejsze miejsca na jednej mapie działającej w czasie rzeczywistym.', imageUrl: '/assests/load.jpg', sortOrder: 0 },
  { id: 'fallback-quests', title: 'WYZWANIA I QUESTY', description: 'Codzienne misje, sezony, osiągnięcia i nagrody, które dają powód, żeby ruszyć w trasę.', imageUrl: '/assests/welcom.jpg', sortOrder: 1 },
  { id: 'fallback-cities', title: 'ODKRYWAJ MIASTA', description: 'Każda podróż odkrywa kolejne obszary i zapisuje Twój ślad na mapie Polski.', imageUrl: '/assests/spots.jpg', sortOrder: 2 },
  { id: 'fallback-profile', title: 'PROFIL I GARAŻ', description: 'Buduj swój profil, pokazuj samochody i zapisuj historię prawdziwych przejazdów.', imageUrl: '/assests/prof.jpg', sortOrder: 3 },
  { id: 'fallback-community', title: 'SPOŁECZNOŚĆ', description: 'Spoty, wydarzenia, dyskusje i ludzie, z którymi motoryzacja nabiera nowego wymiaru.', imageUrl: '/assests/commu.jpg', sortOrder: 4 },
  { id: 'fallback-stats', title: 'PEŁNE STATYSTYKI', description: 'Kilometry, prędkość, punkty, serie i pozycja w rankingu — wszystko w jednym miejscu.', imageUrl: '/assests/load.jpg', sortOrder: 5 },
];

export function resolveMediaUrl(url) {
  if (!url) return '';
  if (/^(https?:)?\/\//i.test(url) || url.startsWith('data:')) return url;
  if (url.startsWith('/assests/')) return url;
  return `${API_ROOT.replace(/\/$/, '')}/${url.replace(/^\//, '')}`;
}

export async function loadLandingData(signal) {
  const [featureResult, rankingResult] = await Promise.allSettled([
    fetch(`${API_ROOT}/api/landing/features`, { signal }).then((response) => {
      if (!response.ok) throw new Error('features');
      return response.json();
    }),
    fetch(`${API_ROOT}/api/landing/ranking`, { signal }).then((response) => {
      if (!response.ok) throw new Error('ranking');
      return response.json();
    }),
  ]);

  return {
    features: featureResult.status === 'fulfilled' && Array.isArray(featureResult.value?.items) && featureResult.value.items.length
      ? featureResult.value.items
      : FALLBACK_FEATURES,
    ranking: rankingResult.status === 'fulfilled' && Array.isArray(rankingResult.value?.users)
      ? rankingResult.value.users
      : null,
    rankingError: rankingResult.status === 'rejected',
  };
}
